/**
 * Get all dynamic labels for a given payoff method
 * @param {number} payoffMethod - The payoff method (0=RULE_OF_78, 1=SIMPLE_INT, 3=SCHEDULE_INT, 4=LEASE, 5=RENT2OWN)
 * @returns {object} - Object with all dynamic labels
 */
export const getPayoffMethodLabels = (payoffMethod) => {
	const isRentBased = payoffMethod === 4 || payoffMethod === 5;
	const isLease = payoffMethod === 4;

	return {
		// Finance/Rent Charge
		financeCharge: isRentBased ? "Rent Charge" : "Finance Charge",

		// Amount Financed / Capitalized Cost
		amountFinanced: isLease ? "Capitalized Cost" : "Amount Financed",

		// Interest/Rent terminology
		interestPaid: isRentBased ? "Rent Paid" : "Interest Paid",
		interestDue: isRentBased ? "Rent Due" : "Interest Due",
		interestAccrued: isRentBased ? "Remain Rent " : "Interest Accrued",
		additionalInterest: isRentBased ? "Additional Rent" : "Additional Interest",

		// APR / Money Factor / Rate
		apr: isLease ? "Money Factor" : payoffMethod === 5 ? "Rate (%)" : "APR (%)",

		// Principal/Principle
		principal: isLease ? "Depreciation" : "Principal",
		principalPaid: isLease ? "Depreciation Paid" : "Principal Paid",
		principalDue: isLease ? "Depreciation Due" : "Principal Due",
		principleRemaining: isLease
			? "Remaining Depreciation"
			: "Remaining Principal",
		remainPrinciple: isLease ? "Remain Depreciation" : "Remain Principal",

		// Balance labels
		princBal: isLease ? "Depreciation Bal" : "Principal Bal",
		loanBal: isLease ? "Lease Bal" : "Loan Bal",

		// Loan terminology
		principleLoan: isLease ? "Depreciation (Lease)" : "Principal (Loan)",

		// Payment labels
		regularPayment: isLease
			? "Lease Payment"
			: payoffMethod === 5
			? "Rent Payment"
			: "Regular Payment",
		downPayment: isLease ? "Drive Off" : "Down Payment",
	};
};
